/**
 * Customer Portal API
 * See `api-description.md` for detailed description.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnergyPriceValue } from './energyPriceValue';


export interface MeteringDataAccountingInterval { 
    /**
     * Timestamp of the accounting interval interval begin time in UTC
     */
    fromTimestamp: string;
    /**
     * Timestamp of the accounting interval interval end time in UTC
     */
    toTimestamp: string;
    /**
     * Date and time of the accounting interval interval begin in local time zone (EET).
     */
    fromDateTime?: string;
    /**
     * Date and time of the accounting interval interval end in local time zone (EET).
     */
    toDateTime?: string;
    /**
     * Is the interval auto-generated for DST transition
     */
    isDstTransition?: boolean;
    /**
     * Consumption in kWh
     */
    consumptionKwh?: number;
    /**
     * Production in kWh
     */
    productionKwh?: number;
    /**
     * Consumption in m3 (used for gas metering data)
     */
    consumptionM3?: number;
    /**
     * Production in m3 (used for gas metering data)
     */
    productionM3?: number;
    marketPrice?: EnergyPriceValue;
    consumptionPriceTotal?: EnergyPriceValue;
    productionPriceTotal?: EnergyPriceValue;
}

